export default __webpack_public_path__ + "static/media/features_card4.a6109b2e.svg";